import styled from 'styled-components';
import colors from '../../../assets/styles/colors';

export const ConformityContainer = styled.div``;

export const ConformityInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

export const ConformityInfoIconWarning = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background: ${colors.bgTertiary};
  margin-right: 15px;
`;

export const ConformityInfoIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background: ${prop => prop.background ? colors.textHyperlink : colors.bgDanger};
  margin-right: 15px;
`;

export const ConformityFooter = styled.div`
  width: 80%;
  display: flex;
  justify-content: flex-end;
`;

export const ConformityModalDescriptionParagraph = styled.p`
  font-size: 14px;
  line-height: 22px;
  color: ${colors.textPrimary};
  text-align: center;
`;

export const ConformityModalDescriptionItemContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ConformityModalDescriptionItemLabel = styled.span`
  font-size: 14px;
  line-height: 22px;
  color: ${colors.textPrimary};
  text-align: center;
  font-weight: bold;
`;
